import { GetPendingList } from "@/services/application.service";
import type { ApplicationData } from "@/types/Application/application";
import { message } from "antd";
import { useEffect, useState } from "react";

export function useApplicationPending() {
  const [loading, setLoading] = useState(true);
  const [applicationPendingList, setApplicationPendingList] =
    useState<ApplicationData | null>(null);

  const fetchPendingList = async (
    search = "",
    pageNumber = 1,
    pageSize = 25,
    categoryKey = "",
    dateFrom = "",
  ) => {
    try {
      setLoading(true);

      const response = await GetPendingList({
        pageNumber,
        pageSize,
        search,
        dateFrom,
        categoryKey,
      });

      setApplicationPendingList(response.data);
    } catch (error) {
      message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan senarai permohonan",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingList();
  }, []);

  return {
    fetchPendingList,
    loading,
    applicationPendingList,
  };
}